const KEY = "opx_cookie_consent";
const VERSION = 1;
export const OPEN_EVENT = "opx:open-cookie-settings";

export function getConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    return c && c.v === VERSION ? c : null;
  } catch {
    return null;
  }
}

export function hasGPC() {
  return typeof navigator !== "undefined" && navigator.globalPrivacyControl === true;
}

export function saveConsent(analytics) {
  const c = { v: VERSION, analytics: Boolean(analytics), ts: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(c));
  applyConsent(c);
  return c;
}

export function applyConsent(c) {
  const ph = window.posthog;
  if (!ph || typeof ph.opt_in_capturing !== "function") return;
  if (c?.analytics) {
    ph.opt_in_capturing();
    ph.set_config?.({ disable_session_recording: false });
    ph.startSessionRecording?.();
  } else {
    ph.opt_out_capturing?.();
    ph.stopSessionRecording?.();
    clearAnalyticsCookies();
  }
}

function clearAnalyticsCookies() {
  const host = window.location.hostname;
  document.cookie.split(";").forEach((raw) => {
    const name = raw.split("=")[0].trim();
    if (!name.startsWith("ph_")) return;
    document.cookie = `${name}=; Max-Age=0; path=/`;
    document.cookie = `${name}=; Max-Age=0; path=/; domain=${host}`;
    document.cookie = `${name}=; Max-Age=0; path=/; domain=.${host.split(".").slice(-2).join(".")}`;
  });
}

export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_EVENT));
}
